'use strict';

import {Component, OnDestroy, OnInit} from "@angular/core";
import {UserService} from "../common/user.service";
import {LoggerService} from "../common/logger.service";
import {MarkupService} from "../common/markup.service";
import {BaseComponent} from "../base.component";
import {ActivatedRoute, Router} from "@angular/router";
import {SkinAnalyzerService} from "../skin-analyzer/skin-analyzer.service";
import {Subscription} from "rxjs";
import {map} from "rxjs/operators";

@Component({
    selector: 'landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent extends BaseComponent implements OnInit, OnDestroy {

    subscriptions: Subscription = new Subscription();

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private markupService: MarkupService,
        private route: ActivatedRoute,
        private skinAnalyzerService: SkinAnalyzerService,
        private router: Router,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.markupService.setToDefaultTitle();
        this.markupService.setOgDefault();

        this.route.queryParams.subscribe(params => {
            if (params["openSkinAnalyzer"] === "true") {
                this.initSkinConfigLoader();
                this.subscriptions.add(
                    this.skinAnalyzerService.startAnalyzerFresh().subscribe()
                );
            }
        });
    }

    initSkinConfigLoader() {
        this.subscriptions.add(
            this.userService.getShopUser().pipe(
                map(shopUser => {
                    this.skinAnalyzerService.initSkinAnalyzer(shopUser, this.router);
                })
            ).subscribe()
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
